import PropTypes from 'prop-types';
import { getInitials } from '../../../../utils/getInitials';

const UserAvatar = ({ imageUrl, user, boja }) => {
  return (
    <div>
      {imageUrl === 'null' ? (
        <div
          className="header-avatar"
          style={{ backgroundColor: boja || localStorage.boja, color: '#fff' }}
        >
          <span>{getInitials(user)}</span>
        </div>
      ) : (
        <div>
          <img className="header-image" src={imageUrl} alt="User avatar" />
        </div>
      )}
    </div>
  );
};

export default UserAvatar;

UserAvatar.propTypes = {
  imageUrl: PropTypes.string.isRequired,
  user: PropTypes.string,
  boja: PropTypes.string,
};
